import { BackgroundContinuation } from '@src/theme/Decoration';
import { Landscape, type LandscapeProps } from '@src/components/Landscape/Landscape';
import type { ReactNode } from 'react';
import { classes } from '@src/components/layout/space';
import { testIdAttr } from '@src/components/testId';
import './Page.css';

export interface PageProps {
  children: ReactNode;
  /** Drop the viewport height — a specimen of Page, not the real one. */
  flush?: boolean;
  landscape?: LandscapeProps['appearance'] | false;
  landscapeForeground?: ReactNode;
  landscapeOverlay?: ReactNode;
  className?: string;
  testId?: string;
}

/** The viewport: page background, full height, a column. */
export function Page({
  children,
  flush = false,
  landscape = 'soft',
  landscapeForeground,
  landscapeOverlay,
  className,
  testId,
}: PageProps) {
  return (
    <div
      className={classes(
        'page',
        flush && 'page--flush',
        !flush && landscape !== false && 'page--landscape',
        landscape === 'clear' && 'page--landscape-clear',
        className,
      )}
      {...(flush ? undefined : { 'data-app-version': 'v2' })}
      {...testIdAttr(testId)}
    >
      {!flush && landscape !== false ? (
        <div
          className={classes('page__background', landscape === 'soft' && 'page__background--soft')}
        >
          <Landscape appearance={landscape} foreground={landscapeForeground} />
          <BackgroundContinuation />
        </div>
      ) : null}
      {!flush && landscape !== false && landscapeOverlay ? (
        <div className="page__landscape-overlay">{landscapeOverlay}</div>
      ) : null}
      {children}
    </div>
  );
}
